import { render } from "./Course.vue?vue&type=template&id=5c688f5a&scoped=true"
import script from "./Course.vue?vue&type=script&lang=ts"
export * from "./Course.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-5c688f5a"

export default script